/**
 * Constants for ZoomModalIconComponent
 */

export const ZOOM_MODAL_ICON_WEB_COMPONENT = 'zoom-modal-icon-component';
